export default class SideAccordion{
	constructor(){
		const accordions = document.querySelectorAll(".sideaccordion");
		accordions.forEach(accordion=>{
			const label = accordion.querySelector(".sideaccordion__label");
			const body = accordion.querySelector(".sideaccordion__body");
			const container = accordion.querySelector(".sideaccordion__body__container");
			let isOpen = false;

			label.addEventListener("click", ()=>{
				if(isOpen){
					isOpen = false;
					accordion.classList.remove("open");
					body.removeEventListener("transitionend", transitionEnd);
					body.classList.remove("transitioning");
					body.style.height = container.offsetHeight+"px";
					requestAnimationFrame(()=>{requestAnimationFrame(()=>{
						body.classList.add("transitioning");
						body.style.height = "0px";
						body.addEventListener("transitionend", transitionEnd, {once:true});
					})});
				}else{
					isOpen = true;
					accordion.classList.add("open");
					body.removeEventListener("transitionend", transitionEnd);
					body.classList.remove("transitioning");
					body.style.height = "0px";
					requestAnimationFrame(()=>{requestAnimationFrame(()=>{
						body.classList.add("transitioning");
						body.style.height = container.offsetHeight+"px";
						body.addEventListener("transitionend", transitionEnd, {once:true});
					})});
				}
			});

			const transitionEnd = ()=>{
				body.classList.remove("transitioning");
				if(isOpen){
					body.style.height = "auto";
				}else{
					body.style.height = "0px";
				}
				if(window.smoothscroller) window.smoothscroller.refresh();	
				window.ScrollTrigger.refresh();
			}
		});
	}
}